import { useState } from "react";

const useIsRestoredId = (storeKey: string, id: string | undefined): boolean => {
  const [restoredId] = useState(() => localStorage.getItem(storeKey));

  return id === restoredId;
};

export default useIsRestoredId;
